module.exports = __webpack_public_path__ + "static/5-bb24f87f4fccd856288ea155bf2c3bdb.jpeg";